import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import TextsmsOutlinedIcon from "@mui/icons-material/TextsmsOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { Input } from "@mui/material";
import { useContext, useState } from "react";

import Modal from "../../../Component/Modal/Modal";
import MUIIconButton from "../../../Component/UI/MUIIconButton/MUIIconButton";
import { LLM_OPTIONS } from "../../../utils/constant";
// import { DiscoveryContext } from "../discovery-context";
import classes from "./HistoryItem.module.css";
import { DiscoveryContext as DiscoveryContextV1 } from "../discovery-context";
import { DiscoveryContext as DiscoveryContextV2 } from "../../DiscoveryV2/discovery-context";

export default function HistoryItem({ item, onDelete, onUpdate, isOldHistory }) {
  const [name, setName] = useState(item?.name || item.entity);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isError, setIsError] = useState(false);
  const discoveryCtx = useContext(isOldHistory ? DiscoveryContextV2 : DiscoveryContextV1);

  function deleteHistoryItemHandler() {
    setShowDeleteDialog(false);
    onDelete(item.id);
  }

  function handleDoneEditing() {
    if (isError) {
      return;
    }
    setIsError(false);
    setIsEditing(false);
    if (
      item.name.toString().toLowerCase().trim() ==
      name.toString().toLowerCase().trim()
    ) {
      return;
    }
    onUpdate(item.id, name);
  }

  function handleInputChange(e) {
    const enteredInput = e.target.value;
    if (enteredInput.trim().length === 0) {
      setIsError(true);
    } else {
      setIsError(false);
    }
    setName(e.target.value);
  }

  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      setName(item?.name || item.entity);
      setIsError(false);
      setIsEditing(false);
    }
  };

  const type = item.type ?? "brand";

  const llmName =
    LLM_OPTIONS.find((option) => option.value === item?.llm)?.name || "GPT-4o-Chat-Offline";

  return (
    <div
      className={classes.container}
      style={{
        borderLeft: `4px solid ${type === "brand" ? "#1976d2" : "green"}`,
      }}
    >
      <Modal
        handleClose={() => setShowDeleteDialog(false)}
        handleConfirm={deleteHistoryItemHandler}
        open={showDeleteDialog}
        title="Delete History?"
        showActions
        confirmBtnText="Delete"
        confirmBtnColor="error"
      >
        Do you want to delete this item - {name}?
      </Modal>
      <div className={classes.text_container}>
        <TextsmsOutlinedIcon />
        {!isEditing && (
          <div>
            <span title={item.name} className={classes.text}>
              {item.name}
            </span>
            <div className={classes.meta}>
              <span className={classes.sub_text} title={item?.category}>
                {item?.category}
              </span>
              <span>&middot;</span>
              {item?.market && (
                <>
                  <span className={classes.sub_text} title={item?.market}>
                    {item?.market}
                  </span>
                  <span>&middot;</span>
                </>
              )}
              <span className={classes.sub_text} title={llmName}>
                {llmName}
              </span>
            </div>
          </div>
        )}
        {isEditing && (
          <Input
            disableUnderline
            className={classes.input}
            style={{ borderColor: isError ? "red" : "gray" }}
            type="text"
            value={name}
            onKeyDown={handleKeyDown}
            onChange={handleInputChange}
          />
        )}
      </div>
      <div className={classes.action}>
        {!isEditing && (
          <>
            <MUIIconButton
              sx={{ color: "#000" }}
              disabled={discoveryCtx.loading}
              onClick={() => {
                discoveryCtx.resetState();
                setIsEditing(false);
                let updatedItem = { ...item.json_data, id: item.id };

                let coreAttributeSummary =
                  updatedItem?.core_attributes?.summary ?? "";
                if (!coreAttributeSummary) {
                  updatedItem?.core_attributes &&
                    updatedItem?.core_attributes?.products &&
                    updatedItem?.core_attributes?.products.map((product) => {
                      coreAttributeSummary += product.summary;
                      coreAttributeSummary += "\n\n";
                    });
                }
                discoveryCtx.updateEntireState({
                  ...updatedItem,
                  core_attributes: {
                    ...updatedItem.core_attributes,
                    summary: coreAttributeSummary,
                  },
                  is_launched: true,
                  loading: false,
                });
                if (isOldHistory) {
                  discoveryCtx.updateTransactionHistory([]);
                }
              }}
            >
              <VisibilityOutlinedIcon />
            </MUIIconButton>
            {!isOldHistory && (
              <>
                <MUIIconButton
                  disabled={discoveryCtx.loading}
                  sx={{ color: "#000" }}
                  onClick={() => setIsEditing(true)}
                >
                  <DriveFileRenameOutlineOutlinedIcon />
                </MUIIconButton>

                <MUIIconButton
                  sx={{ color: "#000" }}
                  onClick={() => setShowDeleteDialog(true)}
                >
                  <DeleteOutlineOutlinedIcon />
                </MUIIconButton>
              </>
            )}

          </>
        )}
        {isEditing && (
          <MUIIconButton onClick={handleDoneEditing}>
            <DoneOutlinedIcon />
          </MUIIconButton>
        )}
      </div>
    </div>
  );
}
